module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container blog-display"
  }, [_c('div', {
    staticClass: "inner-blog"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "about-blog"
  }, [_c('h1', {
    staticClass: "blog_title"
  }, [_vm._v("Barcelona implements Europe’s largest car ban to-date in a leap to reach WHO standard air quality")]), _vm._v(" "), _c('h2', {
    staticClass: "blog_subhead"
  }, [_vm._v("The proposed car ban will affect residents in Barcelona and 39 surrounding municipalities, removing more than 100,000 cars from the roads.")]), _vm._v(" "), _c('h3', {
    staticClass: "blog_date_author"
  }, [_vm._v("APRIL 7, 2017 - RONNIE AGYEMAN")]), _vm._v(" "), _c('div', {
    staticClass: "blog_content"
  }, [_c('big', [_c('p', [_vm._v("Air pollution is a global problem requiring a global solution. ")]), _vm._v(" "), _c('p', [_vm._v("The AirVisual community believes that education and awareness are the seeds of change. In order to realize a future liberated from air pollution concerns, a global understanding of the problem must be cultivated. ")]), _vm._v(" "), _c('p', [_vm._v("Our online community seeks to grow awareness worldwide by providing community members no-nonsense information and access to historical, real-time and forecast air quality data. ")]), _vm._v(" "), _c('p', [_vm._v("By equipping users with these tools, we believe we can change the world. The key is in cultivating a passionate community that fosters mutual collaboration. When we work together to create novel research, advice, opinions, and share monitoring data - we can begin to make a global impact. ")]), _vm._v(" "), _c('p', [_vm._v("At the very heart of the community is a dynamic team of programmers, developers, designers, environmental scientists, meteorological experts and chemical engineers representing 6 countries, from 4 different continents, with 1 overarching commonality - a passion for the world we live in and the air we breathe.")]), _vm._v(" "), _c('p', [_vm._v("Each of us share a vision of a world free from air quality concerns. To realize this future, we have harnessed our passion, enthusiasm and dedication to seek a framework that fosters an organically growing community. ")]), _vm._v(" "), _c('p', [_vm._v("As a crowd-sourced social enterprise - our contributors are an integral part of the team. If you share our passion, we encourage you to contribute to the cause. After all, the community is nothing without you!")])])], 1)])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "posts clearfix"
  }, [_c('div', {
    staticClass: "news_block latest"
  }, [_c('h4', [_vm._v("POPULAR POSTS")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/tower.jpg"),
      "alt": "tower",
      "width": "80",
      "height": "80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "news_in col-xs-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])]), _vm._v(" "), _c('small', [_vm._v("DECEMBER 9, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/map.jpg"),
      "alt": "map",
      "width": "80",
      "height": "80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "news_in col-xs-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2 billion children breathing unsafe outdoor air worldwide")])]), _vm._v(" "), _c('small', [_vm._v("NOVEMBER 8, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/east.jpg"),
      "alt": "east",
      "width": "80",
      "height": "80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "news_in col-xs-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("New WHO model shows 92% of world’s population breathing dangerous air")])]), _vm._v(" "), _c('small', [_vm._v("OCTOBER 8, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a32ea06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsDetails.vue
// module id = 301
// module chunks = 1